import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

export const OpenXAgentListStarIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 22 22">
    <path d="M3 5.25H11.25V6.75H3V5.25ZM3 10.25H10V11.75H3V10.25ZM3 15.25H11.25V16.75H3V15.25Z" />
    <path d="M16.25 3L17.33 5.19L19.75 5.54L18 7.25L18.41 9.66L16.25 8.52L14.09 9.66L14.5 7.25L12.75 5.54L15.17 5.19L16.25 3Z" />
  </SvgIcon>
);
